/* Shell for a universe page (Titles, Platforms): page title + tab bar + outlet.
   The page padding comes from Layout's .main (24px 32px), so no padding here. */
.base {
  width: 100%;
}

.title {
  margin: 0 0 var(--space-3) 0;
  font-family: var(--font-sans);
  font-size: var(--text-2xl);
  font-weight: var(--weight-bold);
  letter-spacing: var(--tracking-tight);
  color: var(--text-primary);
  line-height: 1.2;
}
